import styled from 'styled-components';

export const WarningContainer = styled.div`
  background-color: #F2F2F2;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  gap: 24px;
  align-items: center;
  margin: 24px 0;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #00003C;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #00003C;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  font-size: 14px;
  line-height: normal;
`;

export const Title = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
`;

export const Message = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
`;
